import TalentPoolChart from './TalentPoolChart.container';

export default TalentPoolChart;
